import { LoadingConstants } from '@zg-rentals/rental-manager-env';
import type { StartMetroidAlicornPaymentMethodSessionDto } from '@zg-rentals/ts-adproducts-client';
import {
  AdproductsUserBillingInvoicePaymentApiHandler_getStartGuestPaymentMethodSessionForAccount,
  AdproductsUserBillingInvoicePaymentApiHandler_getStartPaymentMethodSessionForAccount,
} from '@zg-rentals/ts-adproducts-client';
import React from 'react';

export const usePaymentSessionInfo = (accountNumber: string, guestPaySessionId: string | undefined) => {
  const [paymentSessionInfo, setPaymentSessionInfo] = React.useState<StartMetroidAlicornPaymentMethodSessionDto | null>(
    null,
  );
  const [paymentSessionInfoLoadingState, setPaymentSessionInfoLoadingState] = React.useState<string>(
    LoadingConstants.INITIAL,
  );

  React.useEffect(() => {
    setPaymentSessionInfoLoadingState(LoadingConstants.LOADING);
    let StartPaymentMethodSessionHandler;
    if (guestPaySessionId) {
      StartPaymentMethodSessionHandler = () =>
        AdproductsUserBillingInvoicePaymentApiHandler_getStartGuestPaymentMethodSessionForAccount({
          guestPaySessionId,
          accountNumber,
        });
    } else {
      StartPaymentMethodSessionHandler = () =>
        AdproductsUserBillingInvoicePaymentApiHandler_getStartPaymentMethodSessionForAccount({
          accountNumber,
        });
    }
    StartPaymentMethodSessionHandler()
      .then((result) => {
        setPaymentSessionInfoLoadingState(LoadingConstants.SUCCESS);
        return setPaymentSessionInfo(result);
      })
      .catch(() => {
        setPaymentSessionInfoLoadingState(LoadingConstants.ERROR);
      });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  return {
    paymentSessionInfo,
    paymentSessionInfoLoadingState,
  };
};
